export class CurrentDatasetService {
    private currentDataset: any;
    private viewer: any;

    constructor() {
        this.currentDataset = null;
        this.viewer = window.viewer;
    }

    setCurrentDataset(pointcloud: any) {
        this.currentDataset = pointcloud;
        this.viewer.scene.pointclouds.map((pc: any) => {
            if (pc.id == pointcloud.id) pc.active = true;
            else pc.active = false;
        });

        this.viewer.scene.dispatchEvent({
            type: 'currentDataset_changed',
        });
    }

    getCurrentDataset() {
        return this.currentDataset;
    }
}
